import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_MODELS_QUERY_KEY } from './useGetModels';

import ModelsService, {
  CreateModelDto,
  FilterModelsDto,
} from '@/services/ModelsService';

export function useCreateModel(filters: FilterModelsDto) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (dto: CreateModelDto) => ModelsService.createModel(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_MODELS_QUERY_KEY(filters),
      });
    },
  });

  return {
    createModel: mutateAsync,
    isLoading: isPending,
  };
}
